var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoopItemPanel',{attrs:{"title":"Kleur selecteren"}},[_c('div',{staticClass:"canvas::canvas-blocks-common-contentStats-LoopItemPanel"})])}
var staticRenderFns = []

export { render, staticRenderFns }